<template lang="pug">
.gb-card
  slot
</template>
<script>
export default {
  name: 'GbCard'
}
</script>
<style lang="stylus" scoped>
@import '../../stylus/main.styl'
.gb-card
  background-color #fff
  border-radius 2px
  padding 30px
</style>



// WEBPACK FOOTER //
// src/components/atoms/GbCard.vue